import { useRef, useState } from "react"
import { Box, Button, Menu, Portal, Stack } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { Repeat } from "lib/@components/repeat"
import { ResolutionFilterMenuItem } from "./resolution-list-filter-menu-item"
import Iconify from "minimals-template/components/Iconify"

export function ResolutionFilterDropdown({ label, options, value, onChange }) {
    const [anchor, setAnchor] = useState(null)
    const ref = useRef()
    const currentLabel = options.find((o) => o.value === value)?.label ?? value

    return (
        <>
            <Stack
                component={Button}
                onClick={open}
                direction="row"
                alignItems="center"
                spacing={0.5}
                sx={{ cursor: "pointer", fontSize: "85%", color: "text.primary", textTransform: "none" }}
                role="menu"
            >
                <Box sx={{ fontWeight: "bold" }}>{label}:</Box>
                <Box ref={ref} sx={{ fontWeight: "normal" }}>
                    {currentLabel}
                </Box>
                <Iconify icon="mdi:arrow-down-drop" sx={{ fontSize: 24 }} />
            </Stack>
            <Portal>
                <Menu sx={{ zIndex: 3000 }} open={Boolean(anchor)} anchorEl={anchor} onClose={close}>
                    <Bound currentValue={value} onSelect={handleSelect}>
                        <Repeat list={options} item={<ResolutionFilterMenuItem />} />
                    </Bound>
                </Menu>
            </Portal>
        </>
    )

    function open() {
        setAnchor(ref.current)
    }

    function close() {
        setAnchor(null)
    }

    function handleSelect(newValue) {
        onChange(newValue)
        close()
    }
}
